module.exports = __webpack_public_path__ + "static/media/member-photo-jon-kravetz.02620580.png";